import { resto } from '@saucelabs/sl-util-axios';

export const getUserActivity = ({ level = 'user', username, ...params }) => (
  resto.get(`/rest/v1/users/${username}/activity`, { params: { ...params, level } })
);

export const getOrganizationActivity = (params = {}) => (
  resto.get('/rest/v1/activity/organization', { params })
);

export const getTeamsActivity = ({ orgId, teamIds, ...params }) => (
  resto.get('/rest/v1/activity/teams', { params: { ...params, id: teamIds, org_id: orgId } })
);

export const getGroupsActivity = ({ groupIds, orgId, ...params }) => (
  resto.get('/rest/v1/activity/groups', { params: { id: groupIds, org_id: orgId, params } })
);
